import axios from "axios";
import { toast } from "sonner";

const BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const TOKEN_KEY = "ccchaps_portal_token";
const LEARNER_KEY = "ccchaps_portal_learner";

export const portalStorage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clearToken: () => localStorage.removeItem(TOKEN_KEY),
  getLearner: () => {
    const v = localStorage.getItem(LEARNER_KEY);
    return v ? JSON.parse(v) : null;
  },
  setLearner: (l) => localStorage.setItem(LEARNER_KEY, JSON.stringify(l)),
  clearLearner: () => localStorage.removeItem(LEARNER_KEY),
};

const portalApi = axios.create({ baseURL: BASE });

portalApi.interceptors.request.use((config) => {
  const t = portalStorage.getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && err.config?.url && !err.config.url.includes("/portal/auth/")) {
      portalStorage.clearToken();
      portalStorage.clearLearner();
      if (!window.location.pathname.startsWith("/academy/portal/login")) {
        toast.error("Your session ended. Please sign in again.");
        window.location.href = "/academy/portal/login";
      }
    }
    return Promise.reject(err);
  }
);

export default portalApi;

export function formatPortalError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || String(x)).join(", ");
  return err?.message || "Something went wrong.";
}
